import { render, staticRenderFns } from "./ForumPollResults.vue?vue&type=template&id=28adbcff&scoped=true"
import script from "./ForumPollResults.vue?vue&type=script&lang=js"
export * from "./ForumPollResults.vue?vue&type=script&lang=js"
import style0 from "./ForumPollResults.vue?vue&type=style&index=0&id=28adbcff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28adbcff",
  null
  
)

export default component.exports